/**
 * UUID v4 robuste. `crypto.randomUUID` n'existe que sur iOS 15.4+ ET en contexte
 * sécurisé (https) : l'appeler au niveau module ferait CRASHER l'app au chargement
 * sur un Safari plus ancien. On retombe sur `getRandomValues`, puis `Math.random`.
 */
export function uuid(): string {
  const c = globalThis.crypto as Crypto | undefined;
  if (c && typeof c.randomUUID === 'function') return c.randomUUID();
  const b = new Uint8Array(16);
  if (c && typeof c.getRandomValues === 'function') c.getRandomValues(b);
  else for (let i = 0; i < 16; i++) b[i] = Math.floor(Math.random() * 256);
  const oct = (i: number): number => b[i] ?? 0;
  const v6 = (oct(6) & 0x0f) | 0x40; // version 4
  const v8 = (oct(8) & 0x3f) | 0x80; // variant
  const hex = (n: number): string => n.toString(16).padStart(2, '0');
  const part = (a: number, z: number): string => {
    let s = '';
    for (let i = a; i < z; i++) s += hex(i === 6 ? v6 : i === 8 ? v8 : oct(i));
    return s;
  };
  return `${part(0, 4)}-${part(4, 6)}-${part(6, 8)}-${part(8, 10)}-${part(10, 16)}`;
}
